import PropTypes from 'prop-types';

const Drag = ({ color, size, ...props }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path d="M10 5H8v2h2zM10 11H8v2h2zM8 17h2v2H8zM16 5h-2v2h2zM14 11h2v2h-2zM16 17h-2v2h2z" fill={color} />
    </svg>
);

export default Drag;

Drag.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
